// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

import { ChatInteraction } from './chatInteraction';

export class ChatAttachment extends ChatInteraction {
    retrievalUrl: string;
}